import { render, staticRenderFns } from "./Itinerario.vue?vue&type=template&id=5ec0a2ee&scoped=true"
import script from "./Itinerario.vue?vue&type=script&lang=js"
export * from "./Itinerario.vue?vue&type=script&lang=js"
import style0 from "./Itinerario.vue?vue&type=style&index=0&id=5ec0a2ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec0a2ee",
  null
  
)

export default component.exports